import { render, staticRenderFns } from "./withholdGold.vue?vue&type=template&id=07460677&scoped=true"
import script from "./withholdGold.vue?vue&type=script&lang=js"
export * from "./withholdGold.vue?vue&type=script&lang=js"
import style0 from "./withholdGold.vue?vue&type=style&index=0&id=07460677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07460677",
  null
  
)

export default component.exports